import { useSelector } from 'react-redux';
import { canAccessOrganizationPath } from 'util/organizationAccess';
import { callIntercom } from 'helpers/intercom-helper';
import segmentHelper from 'helpers/segment-helper';
import { useAuth } from 'hooks/useAuth';
import { Navigate, useLocation } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import Flex from 'components/common/Flex';

export const ProtectedLayout = ({ children }) => {
  const { token } = useAuth();
  const location = useLocation();
  const roles = useSelector(state => state.authentication?.userRoles ?? []);
  const rolesResolved = useSelector(
    state => state.authentication?.rolesResolved
  );
  const appLoadError = useSelector(state => state.app?.appLoadError);
  if (token == null) {
    segmentHelper.reset();
    callIntercom('shutdown');
    return <Navigate to="/login" state={{ path: location.pathname }} />;
  }

  // After a reload the roles are empty until the user detail request returns.
  // Redirecting before then sends org admins to the dashboard, so wait instead.
  if (rolesResolved === false && !appLoadError) {
    return (
      <Flex justifyContent="center" alignItems="center" className="py-5">
        <Spinner animation="border" size="sm" role="status">
          <span className="visually-hidden">Loading</span>
        </Spinner>
      </Flex>
    );
  }

  if (!canAccessOrganizationPath(roles, location.pathname))
    return <Navigate to="/" replace />;

  return children;
};
